import React from 'react'
import { Form } from 'react-bootstrap'
import Select from 'react-select'
import { Checkbox } from '../../../../components/component-items/checkbox'
import { HoverNotes } from '../../../../components/component-items/hover-notes'
import { colourStyles } from '../../../orders/filter'

interface WarehouseSelectorProps {
  multiWarehouse: boolean
  canSummarizeAllWarehouses: boolean
  summarizeAllWarehouses: boolean
  setSummarizeAllWarehouses: (value: boolean) => void
  warehouseOptions: Array<{ label: string; value: string | number }>
  selectedWarehouses: Array<{ label: string; value: string | number }>
  setSelectedWarehouses: (value: Array<{ label: string; value: string | number }>) => void
  required?: boolean
}

export const WarehouseSelector: React.FC<WarehouseSelectorProps> = ({
  multiWarehouse,
  canSummarizeAllWarehouses,
  summarizeAllWarehouses,
  setSummarizeAllWarehouses,
  warehouseOptions,
  selectedWarehouses,
  setSelectedWarehouses,
  required = false,
}) => {
  if (!multiWarehouse) {
    return null
  }

  return (
    <Form.Group style={{ width: 400 }} className={required ? 'required' : ''}>
      <Form.Label style={{ margin: '1em .25em 0', fontWeight: 500 }}>Warehouses</Form.Label>
      {canSummarizeAllWarehouses && (
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1em' }}>
          <Checkbox selected={summarizeAllWarehouses} setSelected={setSummarizeAllWarehouses} />
          <span style={{ marginLeft: '0.5em' }}></span>
          <HoverNotes
            style={{ padding: '0 1em', lineHeight: '24px' }}
            title="Summarize All Warehouses"
            description="If this is enabled, the report will be summarized across all warehouses. If this is disabled, you can select specific warehouses to include in the report."
          />
        </div>
      )}
      {(!canSummarizeAllWarehouses || !summarizeAllWarehouses) && (
        <Select
          options={warehouseOptions}
          value={selectedWarehouses}
          onChange={setSelectedWarehouses}
          closeMenuOnSelect={false}
          isMulti
          className="basic-multi-select"
          styles={colourStyles}
        />
      )}
    </Form.Group>
  )
}
